import { z } from "zod/v4";

const strictEnvStringSchema = z
  .string()
  .min(1)
  .refine(
    (value) => value === value.trim(),
    "Public env values must not include surrounding whitespace.",
  )
  .refine(
    (value) => !value.includes(String.raw`\n`) && !value.includes(String.raw`\r`),
    "Public env values must not include escaped newlines.",
  );

const strictLowercaseCsvSchema = strictEnvStringSchema
  .transform((value) => value.split(","))
  .pipe(
    z.array(
      strictEnvStringSchema.refine(
        (value) => value === value.toLowerCase(),
        "CSV entries must already be lowercase.",
      ),
    ),
  );

const GoogleAnalyticsClientEnvSchema = z.object({
  NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID: strictEnvStringSchema.optional(),
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_HOSTS: strictLowercaseCsvSchema
    .optional()
    .default([]),
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_ORIGINS: strictLowercaseCsvSchema
    .optional()
    .default([]),
});

const parsedGoogleAnalyticsClientEnv = GoogleAnalyticsClientEnvSchema.parse({
  NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID:
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_HOSTS:
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_HOSTS,
  NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_ORIGINS:
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_ORIGINS,
});

export const googleAnalyticsClientEnv = {
  measurementId:
    parsedGoogleAnalyticsClientEnv.NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID,
  allowedHosts: parsedGoogleAnalyticsClientEnv.NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_HOSTS,
  allowedOrigins:
    parsedGoogleAnalyticsClientEnv.NEXT_PUBLIC_GOOGLE_ANALYTICS_ALLOWED_ORIGINS,
};
